<app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">
  <div class="flex flex-col w-full h-full min-h-0 overflow-hidden p-1">
    <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

      <div class="flex flex-1 min-h-0">
      <!-- Left Column -->
      <div class="z-[2] flex-[0.3] min-w-[150px] min-h-0 flex flex-col overflow-hidden">
        <div class="mb-2">
          <app-scope-filter 
            [(selectedFilter)]="selectedScopeFilter"
            [userRoles]="userRoles"
            (filterChange)="onScopeFilterChange()">
          </app-scope-filter>
        </div>
        <div class="mb-2">
          <p-button
            class="outlined-button"
            size="small"
            severity="success"
            label="Add Profile"
            [outlined]="true"
            (click)="addItem()">
          </p-button>
        </div>
        <div class="flex-1 min-h-0 overflow-auto">
          <p-listbox
            [scrollHeight]="''"
            [options]="tempDerations"
            [ngModel]="selectedTempDeration()"
            optionLabel="name"
            (onClick)="onSelect($event)">
            <ng-template let-item #item>
              <div class="flex justify-between items-center w-full">
                <div class="flex items-center gap-1 flex-grow min-w-0">
                  <app-catalog-metadata-icon [metadata]="item.metadata"></app-catalog-metadata-icon>
                  <span class="text-sm truncate">{{ item.name }}</span>
                </div>
                <div class="flex items-center gap-1">
                  @if (!deleteProfileCheck(item)) {
                  <i
                    class="pi pi-trash cursor-pointer !text-red-400"
                    (click)="deleteProfile(item)"
                    title="Delete"></i>
                  } @else {
                  <i
                    class="pi pi-lock text-gray-400"
                    title="Locked catalog item, cannot be deleted."></i>
                  }
                </div>
              </div>
            </ng-template>
          </p-listbox>
        </div>
      </div>

      <!-- Right Column -->
      <div class="flex-[0.7] p-2 w-[100px] pb-10 pt-0 flex flex-col min-h-0">
        <!-- Name and Scope Section -->
        <div [class.pointer-events-none]="selectedTempDeration()?.isLocked" [class.opacity-50]="selectedTempDeration()?.isLocked" class="mb-4">
          <div class="flex items-center gap-4">
            <div class="relative z-[2] flex flex-col flex-grow">
              <label for="tempDerationName">Name</label>
              <input
                id="tempDerationName"
                class="flex-grow p-1"
                type="text"
                pInputText
                value="{{selectedTempDeration()?.name}}"
                (change)="onNameChange($event)"
                autocomplete="off"
                #nameField>
            </div>

            @if (selectedTempDeration()) {
            <div class="flex items-center gap-2 pt-5 shrink-0">
              <label class="text-sm font-medium">Scope:</label>

              @if (!selectedTempDeration()?.isLocked && userRoles?.catalogAdmin) {
              <p-button
                [label]="getScopeLabel(selectedTempDeration()?.scope)"
                [severity]="selectedTempDeration()?.scope === CatalogScope.Global ? 'success' : 'info'"
                size="small"
                outlined="true"
                variant="outlined"
                [rounded]="false"
                class="scope-toggle-button"
                (click)="toggleTempDerationScope()"
                [title]="'Click to switch to ' + (selectedTempDeration()?.scope === CatalogScope.User ? 'Global' : 'User')">
              </p-button>
              } @else {
              <p-button
                [label]="getScopeLabel(selectedTempDeration()?.scope ?? CatalogScope.User)"
                [severity]="selectedTempDeration()?.scope === CatalogScope.Global ? 'success' : 'info'"
                size="small"
                outlined="true"
                variant="outlined"
                [rounded]="false"
                class="scope-toggle-button"
                [disabled]="true">
              </p-button>
              }
            </div>
            }
          </div>
        </div>

        <div class="flex items-center gap-3 pb-2">
          <p-selectButton
            class="shrink-0"
            [options]="tablePlotOptions"
            [(ngModel)]="tablePlotSelected"
            optionLabel="label"
            optionValue="value"
            (onChange)="tablePlotToggle()"
            [allowEmpty]="false"
          ></p-selectButton>

          @if (tablePlotSelected === 'plot') {
          <p-selectButton
            class="shrink-0"
            [options]="modes"
            [(ngModel)]="modeSelected"
            optionLabel="label"
            optionValue="value"
            [allowEmpty]="false"
          ></p-selectButton>
          }
        </div>

        @if (tablePlotSelected === 'table') {
        <div class="flex gap-2 mt-2 mb-2">
          <div class="flex items-center gap-2">
            <span class="text-sm text-muted-color pr-2">Temp:</span>
            <app-validated-number-input
              id="temperatureDerationInterpolationTemp"
              [inline]="true"
              [control]="interpolationTemperatureControl"
              [value]="interpolationTemperatureControl.value ?? 0"
              [validation]="interpolationValidation"
              [unit]="temperatureUnit"
              (onChange)="interpolate($event)"
            />
          </div>
          <span class="text-sm text-muted-color">Factor:</span>
          <p-inputNumber [minFractionDigits]="3" [disabled]="true" [ngModel]="interpolatedValue"></p-inputNumber>
        </div>
        }

        @if (tablePlotSelected === 'table') {
          <div class="flex-1 min-h-0" [class.pointer-events-none]="selectedTempDeration()?.isLocked" [class.opacity-50]="selectedTempDeration()?.isLocked">
            <app-units-grid-input
              [tableTitle]="'Temperature Deration'"
              [rows]="tempDerationRows"
              [columns]="tempDerationColumns"
              [userUnits]="userUnits()"
              [autoHeight]="true"
              [allowDeleteRows]="!selectedTempDeration()?.isLocked"
              [minRows]="1"
              [createRow]="createTempDerationRow"
              [commitMode]="'debounced'"
              [commitDebounceMs]="300"
              (cellEdited)="onTemperatureDerationGridChange()"
              (commitRequested)="onTemperatureDerationGridChange()"
              (rowDeleted)="onTempDerationRowDeleted($event)"
              (rowsReset)="onTemperatureDerationGridChange()"
              (pasteApplied)="onTemperatureDerationGridChange()"
            />
          </div>
        }

        @if (tablePlotSelected === 'plot') {
          <app-temperature-deration-plot
            [tempDerations]="tempDerations"
            [selectedTempDeration]="selectedTempDeration()"
            [modeSelected]="modeSelected"
            [temperatureUnit]="temperatureUnit"
            [downloadPlotName]="downloadPlotName"
          ></app-temperature-deration-plot>
        }
      </div>
    </div>
  </div>
</app-tool-loader>
